"use strict";

($dt => {
	
	$dt.Ready = () => {
		// Happens after document is ready on all pages - in terms of browser loading, this is the better spot to use
		
		// Global Features
		$dt.Global.InitAnims();
		$dt.Global.InitHoverItems();
		$dt.Global.InitLocationSwitcher();
		$dt.Global.InitBackTop();
		$dt.Global.InitNav();
		
		// Blocks
		$dt.Util.iterateBlocks((block, block_name) => {
			let loaded = false;
			if ($dt.blocks[block_name]) {
				loaded = true;
				if ($dt.blocks[block_name].LoadBlock) {
					$dt.blocks[block_name].LoadBlock(block);
				}
			}
			return loaded;
		});

		// Registered Autostart Functions
		if ($dt.autostart) {
			// The autostart array allows anonymous registration of ready events to fire after the theme is ready.
			$dt.autostart.forEach(ready => {
				ready();
			});
		}
	};
	
	$dt.Global = {
		
		InitHoverItems: () => {
			if (!$dt.Util.isInternetExplorer() && window.matchMedia("(hover: none)").matches) {
				const items = document.querySelectorAll('.view-hover .link-wrapper');

				if (items) {
					items.forEach(element => {
						element.addEventListener("click", function(e){
							if (!element.classList.contains('item-hover-state-activated')) {
								e.preventDefault();
							}

							//Remove all other classes to allow going through submenus multiple times w/o unintentionally navigating away
							items.forEach(sub_element => {
								sub_element.classList.remove('item-hover-state-activated');
							});
							element.classList.add('item-hover-state-activated');
						});
					});
				}
			}
		},
		
		InitAnims: () => {
			if (!$dt.Util.isInternetExplorer()) {
				const animElements = document.querySelectorAll(".animate-block");
				if (animElements) {
					animElements.forEach(element => {
						$dt.Util.createObserver(element);
					});
				}
			}
		},

		InitLocationSwitcher: () => {
			const selector = document.getElementById('toolbar-campus-selector');
			if (selector) {
				selector.addEventListener('change', () => {
					const href = selector.value;
					if (href && href.length > 0) {
						window.location.href = href;
					}
				});
			}
		},

		InitBackTop: () => {
			const backtop = document.getElementById('backtop');
			//console.log(backtop);
			if (backtop) {
				backtop.addEventListener('click', () => { 
					//console.log('clicked');
					document.body.scrollTop = document.documentElement.scrollTop = 0;
				});
			}
		},

		InitNav: () => {
			const hamburger = document.querySelector(".hamburger");
			const navMenu = document.querySelector('#header .nav-menu');
			const menuItems = document.querySelectorAll('#header .menu-item>a');
			const touchDevice = matchMedia('(hover: none)').matches;
			const body = document.querySelector('body');
			const mainContent = document.getElementById('main-content');
			if (hamburger) {
				hamburger.addEventListener('click', function() {
					hamburger.classList.toggle('active');
					navMenu.classList.toggle('active');
					body.classList.toggle('noscroll');
				});
			}
			if (menuItems) {
				menuItems.forEach(menuItem => {
					menuItem.addEventListener('click', function(e) {
						if (!menuItem.classList.contains('active') && (touchDevice || window.innerWidth < 1200)) {
							menuItems.forEach(menuItem => {
								menuItem.classList.remove('active');
							});
							mainContent.addEventListener('click', function() {
								menuItems.forEach(menuItem => {
									menuItem.classList.remove('active');
								});
							});
							e.preventDefault();
						}
						menuItem.classList.toggle('active');

					});
				});
			}
		},

	};
	
	// Really should try to avoid page templates if possible, but if needed, templates can be defined here so long as each template has an Init and Ready function
	$dt.TemplateLoaders = {
		/*'sample': {
			Ready: () => {
				// Happens after the global Ready function on pages using `sample` template only
				//console.log('sample template ready');
			}
		}*/
	};
		
	// Utility Functions
	$dt.Util = {
		/**
		 * Checks whether browser = IE
		 */
		isInternetExplorer: () => {
			return typeof(window.document.documentMode) !== 'undefined';
		},

		/**
		 * Util functions for Intersection Observer
		 * @param {HTMLElement} element 
		 */
		createObserver: (element) => {
			const options = {
			  root: null,
			  rootMargin: "0px",
			  threshold: $dt.Util.buildThresholdList()
			};
		  
			const observer = new IntersectionObserver($dt.Util.handleIntersect, options);
			observer.observe(element);
		},

		buildThresholdList: () => {
			const thresholds = [];
			const numSteps = 20;
		  
			for (let i = 1.0; i <= numSteps; i++) {
			  const ratio = i / numSteps;
			  thresholds.push(ratio);
			}
		  
			thresholds.push(0);
			return thresholds;
		},

		handleIntersect: entries => {
			document.body.classList.add('animations-available');
			entries.forEach(entry => {
				if (entry.intersectionRatio > 0.29) {
					entry.target.classList.add("animation-fade-in");
				}
			});
		},

		/**
		 * Loops through each block found on the page and sends them into a callback sending the block and block name into the callback (onBlockFound)
		 * @param {Function<HTMLElement, string>} onBlockFound Return true if the block functionality desired is executed.
		 */
		iterateBlocks: onBlockFound => {
			const blocks = document.querySelectorAll('.block-content');
			if (blocks) {
				blocks.forEach(block => {
					let loaded = false;
					block.classList.forEach(class_name => {
						if (!loaded && class_name !== 'block-content' && /^block-[-a-zA-Z0-9]+$/.test(class_name)) {
							const block_name = class_name.replace(/^block-/, '');
							loaded = onBlockFound(block, block_name);
						}
					});
				});
			}
		},

		/**
		 * Get page template name from the body classes -- this will convert hyphens to underscores.
		 */
		getPageTemplateNames: () => {
			const templates = [];
			
			document.body.classList.forEach(body_class => {
				let __isFound = false;
				const cleaned = body_class.replace(/^page-template-/, '').replace(/-/g, '_');
				templates.forEach(t => {
					if (t === cleaned) {
						__isFound = true;
					}
				});
				if (!__isFound) {
					templates.push(cleaned);
				}
			});

			return templates;
		},
		
		/**
		 * Retrieves the post ID for the current page.
		 */
		post_id: false,
		getPostID: () => {
			if ($dt.Util.post_id === false) {
				const matches = /(post|page)-id-([0-9]+)/.exec(document.body.className);
				if (matches && matches.length > 2) {
					$dt.Util.post_id = parseInt(matches[2]);
				} else {
					// Not an actual post/page
					$dt.Util.post_id = -1;
				}
			}
			return $dt.Util.post_id;
		},
		
		// Retrieve a cookie -- Warning: you cannot retrieve HTTP_Only cookies
		getCookie: (name) => {
			const value = "; " + document.cookie;
			const parts = value.split("; " + name + "=");
			if (parts.length === 2) {
				return parts.pop().split(";").shift();
			}
		},/*

		// Retrieve a querystring parameter
		getParameterByName: (name, url) => {
			if (!url) {
				url = window.location.href;
			}
			name = name.replace(/[\[\]]/g, "\\$&");
			const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
				results = regex.exec(url);
			if (!results) {
				return null;
			}
			if (!results[2]) {
				return '';
			}
			return decodeURIComponent(results[2].replace(/\+/g, " "));
		},*/

		// A function that will help ensure a delayed function only runs once in a potential asynchronous conflict
		debounce: (fn, threshold) => {
			let timeout;
			return () => {
				if (timeout) {
					clearTimeout(timeout);
				}
				timeout = setTimeout(() => {
					fn();
					timeout = null;
				}, threshold || 100);
			};
		},

		/**
		 * Returns a video object with type and video id based on a loosely structured string url input
		 * @param {string} url 
		 * @returns {type, video_id}
		 */
		getVideoDataBasedOnUrl: url => {
			const video = {
				type: false,
				video_id: false,
				get_iframe: () => {
					let html = '';
					switch (video.type) {
						case 'vimeo':
							html = '<iframe src="https://player.vimeo.com/video/' + video.video_id + '?h=a1772ddb48&color=000000&byline=0&portrait=0&badge=0" width="100%" height="100%" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe>';
							break;
						case 'youtube':
							html = '<iframe width="100%" height="100%" src="https://www.youtube.com/embed/' + video.video_id + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
							break;
						default:
							html = '<!-- unrecognized video url: ' + url + ' -->';
							break;
					}
					return html;
				}
			};

			video.video_id = $dt.Util.matchYoutubeUrl(url);
			if (video.video_id) {
				video.type = 'youtube';
			} else {
				video.video_id = $dt.Util.matchVimeoUrl(url);
				if (video.video_id) {
					video.type = 'vimeo';
				}
			}

			return video;
		},

		htmlDecode: (input) => {
			const entities = {
				'&amp;': '&',
				'&lt;': '<',
				'&gt;': '>',
				'&quot;': '"',
				'&#39;': "'"
			};
			return input.replace(/&amp;|&lt;|&gt;|&quot;|&#39;/g, match => entities[match]);
		},

		// A function for checking to see if a URL is a youtube link.
		matchYoutubeUrl: (url) => {
			const p = /^(?:https?:\/\/)?(?:m\.|www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
			const match = url.match(p);
			if (match) {
				return match[1];
			}
			return false;
		},

		// A function for checking to see if a URL is a vimeo link.
		matchVimeoUrl: (url) => {
			// https://player.vimeo.com/video/25494000, https://vimeo.com/25494000
			const p = /^(?:https?:\/\/)?(player\.)?vimeo.com(\/video)?\/([0-9]+)(?:\S+)?$/;
			const match = url.match(p);
			if (match) {
				return match[3];
			}
			return false;
		},
	};
	
	/**
	 * DO NOT EDIT PAST THIS POINT
	 */

	// Useful for waiting on libraries that load async
	$dt.OnLibraryAvailable = (libs, onReady, min_wait_seconds, max_checks, onFailed) => {
		// Useful for waiting on deferred libraries to load. An interval is set and periodically checked until the library requested is available.
		const waiter = {
			checks: 0,
			max_checks: typeof(max_checks) === 'undefined' ? 10 : max_checks,
			min_wait: typeof(min_wait_seconds) === 'undefined' ? 1000 : min_wait_seconds * 1000,
			clear_interval: () => {
				clearInterval(waiter.interval_id);
				waiter.interval_id = -1;
			},
			check_ready: () => {
				let is_ready = true;
				libs.forEach(lib => {
					is_ready = is_ready && typeof(window[lib]) !== 'undefined';
				});
				if (is_ready) {
					onReady();
					waiter.clear_interval();
				} else {
					if (++waiter.checks >= waiter.max_checks) {
						waiter.clear_interval();
						if (typeof(onFailed) !== 'undefined') {
							onFailed();
						} else {
							console.warn('Couldn\'t load one or more libraries.', libs);
						}
					}
				}

				return is_ready;
			},
			interval_id: -1
		};

		if (!waiter.check_ready()) {
			waiter.interval_id = setInterval(() => { waiter.check_ready(); }, waiter.min_wait);
		}

		return waiter;
	};

	// When develforms is ready, this method will send $df to callback (v2.x only)
	$dt.OnDevelformsReady = callback => {
		const check = setInterval(() => {
			if (typeof(window.develforms) !== 'undefined' && window.develforms.ready) {
				clearInterval(check);
				callback(window.develforms);
			}
		}, 500);
	};

	// Find custom template (if any)
	const page_templates = $dt.Util.getPageTemplateNames();

	// Run global Ready
	$dt.Ready();

	// If a page template was previously found, run template Ready
	for (let i = 0; i < page_templates.length; i++) {
		const template = page_templates[i];
		if (typeof($dt.TemplateLoaders[template]) !== 'undefined') {
			$dt.TemplateLoaders[template].Ready();
		}
	}

	// Google Maps Block Triggers (if enabled)
	/*if ($dt.gmaps && $dt.InitGoogleMapsBlocks) {
		$dt.InitGoogleMapsBlocks();
	}*/
	
})(window.d3_wp_themejs);
